import { render, staticRenderFns } from "./dashboard-entities-view.vue?vue&type=template&id=55326a60&scoped=true&"
import script from "./dashboard-entities-view.vue?vue&type=script&lang=ts&"
export * from "./dashboard-entities-view.vue?vue&type=script&lang=ts&"
import style0 from "./dashboard-entities-view.vue?vue&type=style&index=0&id=55326a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55326a60",
  null
  
)

export default component.exports